import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retryDelay: 1500,
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
      retry: (failureCount, error) => {
        // handles API timeouts, status code is not returned
        if (error.message.includes('Network Error')) {
          // return false to not retry a fetch request, it takes 30+ seconds and looks like an infinite spinning loader component
          return false;
        }
        return failureCount < 3;
      },
    },
  },
});

export default queryClient;
